<template>
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            :title2="headTitle"
          ></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <h3 class="title">{{ headTitle }}</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <div class="input_div">
                <p>风采名称</p>
                <el-input
                  class="input"
                  v-model="info.title"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div class="input_div">
                <p>风采分类</p>
                <el-select
                  class="input"
                  v-model="association"
                  placeholder="请选择"
                  multiple
                  collapse-tags
                  @change="changeAssociation"
                >
                  <el-option
                    v-for="item in classifyOptions"
                    :key="item.id"
                    :value="item.id"
                    :label="item.title"
                  ></el-option>
                </el-select>
              </div>
              <div class="input_div">
                <p>风采时间</p>
                <el-date-picker
                  class="input"
                  v-model="createTime"
                  type="datetime"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
              </div>
              <div class="input_div">
                <p>状态</p>
                <el-select
                  class="input"
                  v-model="info.status"
                  placeholder="请选择"
                  collapse-tags
                >
                  <el-option
                    v-for="item in pushOptions"
                    :key="item.en"
                    :value="item.en"
                    :label="item.cn"
                  ></el-option>
                </el-select>
              </div>
              <div class="input_div">
                <p>是否开放游客查看</p>
                <el-select
                  class="input"
                  v-model="info.public"
                  placeholder="请选择"
                  collapse-tags
                >
                  <el-option
                    v-for="item in yesorno"
                    :key="item.en"
                    :value="item.en"
                    :label="item.cn"
                  ></el-option>
                </el-select>
              </div>
              <div style="clear: both"></div>
              <div class="input_div">
                <p>风采封面</p>
                <input
                  type="file"
                  accept="image/*"
                  style="display: none"
                  id="uploadfile"
                  @change="openFolder"
                />
                <el-button size="mini" @click="openImage()"
                  >选择本地图片</el-button
                >
                <el-image class="imageDiv" :src="imageUrl" fit="scale-down">
                  <div
                    slot="error"
                    class="image-slot"
                    style="position: absolute; top: 50%; left: 50%"
                  >
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div style="clear: both"></div>
              <div class="input_div">
                <p>详情类型</p>
                <el-select
                  style="width: 100%"
                  v-model="info.type"
                  placeholder="请选择"
                  collapse-tags
                >
                  <el-option
                    v-for="item in detailsTypesOptions"
                    :key="item.en"
                    :value="item.en"
                    :label="item.cn"
                  ></el-option>
                </el-select>
              </div>
              <div class="input_div" v-if="info.type == 'details'">
                <p>推文链接</p>
                <el-input
                  class="input"
                  v-model="info.details"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div
                class="input_div"
                v-if="info.type == 'rich_text'"
                style="width: 100%"
              >
                <p>文本编辑器</p>
                <VueUeditorWrap
                  :destroy="true"
                  v-model="info.rich_text"
                  :config="editorConfig"
                />
              </div>
            </div>
          </div>
          <FootLayout v-on:saveEdit="saveEdit"></FootLayout>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import { URL_PATH, Editor_Config } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayoutWxapp";
import FootLayout from "@/components/layout/footLayout";
import VueUeditorWrap from "vue-ueditor-wrap";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    FootLayout,
    VueUeditorWrap
  },
  data() {
    return {
      meunItem: null,
      meunTitle: "",
      headTitle: "",
      urlPath: URL_PATH,
      info: { type: "details" },
      classifyOptions: [], //校友风采分类
      detailsTypesOptions: Constant.details_types_filters,
      editorConfig: Editor_Config,
      pushOptions: [{ cn: "已发布", en: "Y" }, { cn: "未发布", en: "N" }], //是否发布
      yesorno: Constant.options_yesorno, //游客是否查看
      association: [],
      createTime: null,
      imageUrl: ""
    };
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      this.newsId = this.$route.query.id;
      this.headTitle = this.newsId == null ? "新增校友风采" : "编辑校友风采";
      this.getAssociationId();
    },
    // 获取详情
    getInfo() {
      var id = this.$route.query.id;
      if (id == null) return;
      var that = this;
      this.$api
        .memorabiliaInfo({
          token: localStorage.getItem("token"),
          id: id
        })
        .then(({ data }) => {
          that.info = data.Data;
          that.createTime = new Date(that.info.create_time * 1000);
          that.imageUrl = that.urlPath + that.info.thumb;
          that.info.association.forEach(ass => {
            that.association.push(ass.id);
          });
        })
        .catch(({ error }) => {});
    },
    // 获取分类
    getAssociationId: function() {
      this.$api
        .getAssociationId({
          token: localStorage.getItem("token")
        })
        .then(({ data }) => {
          this.classifyOptions = [];
          data.Data.forEach(info => {
            this.classifyOptions.push(info);
          });
          this.getInfo();
        })
        .catch(({ error }) => {});
    },
    // 新增
    addInfo: function(form) {
      this.$api
        .updateMemorabilia(form)
        .then(({ data }) => {
          this.$router.back(-1);
        })
        .catch(({ error }) => {});
    },
    // 编辑
    updateInfo: function(form) {
      form.append("id", this.info.id);
      this.$api
        .updateMemorabilia(form)
        .then(({ data }) => {
          this.$router.back(-1);
        })
        .catch(({ error }) => {});
    },
    // 选择分类
    changeAssociation(tag) {
      if (tag.length > 1) {
        tag.forEach((id, index) => {
          if (id == 0) {
            this.association = [tag[index]];
            return;
          }
        });
      }
    },
    // 选择图片
    openImage() {
      document.getElementById("uploadfile").click();
    },
    openFolder(e) {
      var that = this;
      var image = e.target.files[0];
      var reader = new FileReader();
      reader.onload = function(evt) {
        that.imageUrl = evt.target.result;
      };
      reader.readAsDataURL(image);
      this.info.thumb = image;
    },
    // 保存
    saveEdit() {
      this.info.association_list = "";
      this.association.forEach(id => {
        this.info.association_list += id + ",";
      });
      var length = this.info.association_list.length;
      if (length > 0) {
        this.info.association_list = this.info.association_list.substring(
          0,
          length - 1
        );
      }
      if (this.createTime) {
        this.info.create_time = this.createTime.getTime() / 1000;
      }
      if (
        StrUtils.isEmpty(this.info.title) ||
        StrUtils.isEmpty(this.info.status) ||
        StrUtils.isEmpty(this.info.public) ||
        StrUtils.isEmpty(this.info.create_time) ||
        StrUtils.isEmpty(this.info.association_list) ||
        StrUtils.isEmpty(this.info.type) ||
        StrUtils.isEmpty(this.info.thumb)
      ) {
        this.$message.error("请先完善数据");
        return;
      }
      var form = new FormData();
      form.append("type", this.info.type);
      if (this.info.type == "details") {
        if (StrUtils.isEmpty(this.info.details)) {
          this.$message.error("推文链接不能为空");
          return;
        } else {
          form.append("details", this.info.details);
        }
      }
      if (this.info.type == "rich_text") {
        if (StrUtils.isEmpty(this.info.rich_text)) {
          this.$message.error("文本编辑器不能为空");
          return;
        } else {
          form.append("rich_text", this.info.rich_text);
        }
      }
      form.append("token", localStorage.getItem("token"));
      form.append("title", this.info.title);
      form.append("status", this.info.status);
      form.append("public", this.info.public);
      form.append("create_time", this.info.create_time);
      form.append("association_list", this.info.association_list);
      form.append("image", this.info.thumb);
      if (this.newsId) {
        this.updateInfo(form);
      } else {
        this.addInfo(form);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-top: 24px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.operateText {
  font-size: 14px;
}

.input_div {
  width: 290px;
  margin-right: 120px;
  margin-bottom: 32px;
  float: left;
}
.input_div .input {
  width: 100%;
}
.input_div p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 8px;
}
</style>

<style lang="less">
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/memorabiliaAdd.vue